<template>
  <div class="w-full flex flex-col gap-2">
    <BaseText v-if="label?.length" type="label" size="sm" class="text-text-muted">
      {{ label }}
    </BaseText>
    <div class="grid gap-2.5" :style="{ gridTemplateColumns: `repeat(${numColumns}, 1fr)` }">
      <button v-for="(option, index) in options" :key="`${renderKey}-option-${index}`"
      class="big-button p-3 flex items-center justify-center rounded-md" :class="{'active': isSelected(option)}"
      @click="handleChange(option)">
        <transition name="checkmark">
          <div v-if="isSelected(option)" class="w-7 h-5 flex-shrink-0">
            <CheckmarkIcon class="text-icon-normal" />
          </div>
        </transition>
        <BaseText type="label" size="sm" class="text-text-muted">
          {{  option[optionLabelKey] }}
        </BaseText>
      </button>
    </div>
  </div>
</template>

<script>  
import CheckmarkIcon from '../../../globals/Icons/NewCheckmarkIcon.vue'

export default {
  name: 'BigButtonGroup',
  components: {
    CheckmarkIcon
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      required: true
    },
    optionValueKey: {
      type: String,
      default: 'value'
    },
    optionLabelKey: {
      type: String,
      default: 'label'
    },
    selectedValue: {
      required: true
    },
    renderKey: {
      type: String,
      required: true
    },
    numColumns: {
      type: Number,
      default: 3
    }
  },
  methods: {
    isSelected (option) {
      return this.selectedValue === option[this.optionValueKey]
    },
    handleChange (option) {
      if (this.isSelected(option)) {
        this.$emit('change', null)
      } else {
        this.$emit('change', option[this.optionValueKey])
      }
    }
  }
}
</script>

<style scoped>
.big-button {
  box-shadow: 0 1px 2px 0 rgba(0, 56, 108, 0.08), 0 0 0 1px rgba(0, 56, 108, 0.08);
  background-color: white;
  transition: box-shadow 100ms ease-in-out, background-color 100ms ease-in-out;
}
.big-button:hover {
  box-shadow: 0 1px 2px 0 rgba(0, 56, 108, 0.12), 0 0 0 1px rgba(0, 56, 108, 0.12);
  background-color: white;
}
.big-button.active, .big-button.active:hover {
  box-shadow: none;
  background-color: #F6F8FA; /* bg-neutral-25 */
}

.checkmark-enter-active {
  animation: checkmarkEnter 300ms ease-in-out;
}
.checkmark-leave-active {
  animation: checkmarkLeave 300ms ease-in-out;
}
@keyframes checkmarkEnter {
  0% { width: 0px; opacity: 0;}
  50% { width: 28px; opacity: 0;}
  100% { width: 28px; opacity: 1;}
}
@keyframes checkmarkLeave {
  0% { width: 28px; opacity: 1;}
  50% { width: 28px; opacity: 0;}
  100% { width: 0px; opacity: 0;}
}
</style>